module.exports = __webpack_public_path__ + "img/social_post.e5f95273.png";